import { Component, Inject } from '@angular/core';
import { HashLocationStrategy } from '@angular/common';


@Component({
    selector: 'message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss']
})
export class MessageComponent {
    
    public message : string;
    public currentStyle :string;
    constructor( ) {       
    }

    public show(){
        return this.message && this.message !== '';
    }

    private setMessage(message) {
        this.message = message;        
    }

    public showError(message) {
        this.setMessage(message);
        this.currentStyle = 'error';
        this.hideAfter();        
    }

    public hideAfter() {
        setTimeout(() => {this.message = '';}, 2000);
    }

    public showSuccess(message) {
        this.setMessage(message);
        this.currentStyle = 'success';
        this.hideAfter();
    }
    
    public showInfo(message) {
        this.setMessage(message);
        this.currentStyle = 'info';
        this.hideAfter();
    }
    
}


// WEBPACK FOOTER //
// ./src/app/components/messages/message.component.ts